<template>
  <div style="padding: 3px">
    <b-table sticky-header ref="table1" stacked="lg" striped hover :items="prestazioniItems"
      :fields="headersPrestazioni" :current-page="1" :per-page="100" sort-icon-left head-variant="light"
      class="sa-b-table">

      <template v-slot:cell(appuntamenti)="row">
        <template v-if="!row.item.new">
          <div class="d-flex justify-content-center" style="gap: 12px; top:0">
            <div class="text-center">
              <label>Eseguiti</label>
              <div style=" display: block ruby;">
                <div :style="{
                  minWidth: '22px',
                  height: '22px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '25px',
                  background: '#218838',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                }">{{ getNumber('ESEGUITO', row.item.appuntamenti) }}
                </div>
              </div>
            </div>
            <div class="text-center">
              <label>Prenotati</label>
              <div style=" display: block ruby;">
                <div :style="{
                  minWidth: '22px',
                  height: '22px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '25px',
                  background: '#FFC107',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                }">{{ getNumber('PRENOTATO', row.item.appuntamenti) }}
                </div>
              </div>
            </div>
            <div class="text-center">
              <label>Ciclo</label>
              <div style=" display: block ruby;">
                <div :style="{
                  minWidth: '22px',
                  height: '22px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '25px',
                  background: '#00a3ff',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                }"> {{ row.item.quantitaErogabile }}
                </div>
              </div>
            </div>
          </div>

        </template>
      </template>
      <template v-slot:cell(quantita)="row">
        <div v-if="row.item.new">
          <b-form-input v-model="prestazione.quantita" type="number"></b-form-input>
        </div>
        <div v-else>
          <b-form-input v-if="!isRowEdit(row)" v-model="selectedRowEditItem.quantita" type="number"></b-form-input>
          <b-form-input v-else :disabled="true" v-model="row.item.quantita" type="number"></b-form-input>
        </div>
      </template>
      <template v-slot:cell(codicePrestazione)="row">
        <div v-if="row.item.new">
          <b-form-input v-model="prestazione.codicePrestazione" list="my-list-id" :disabled="true">
          </b-form-input>
        </div>
        <div v-else>
          <div v-if="!isRowEdit(row)">
            <b-form-input v-model="selectedRowEditItem.codicePrestazione" list="my-list-id"
              :disabled="true"></b-form-input>
          </div>
          <span v-else>
            <b-form-input v-model="row.item.codicePrestazione" :disabled="true" list="my-list-id"></b-form-input>
          </span>
        </div>
      </template>
      <template v-slot:cell(descrizionePrestazione)="row">
        <div v-if="row.item.new">
          <b-input-group>
            <b-form-input v-model="prestazione.descrizionePrestazione" list="my-list-id" :disabled="!isRowEdit(row)">
            </b-form-input>
            <datalist id="my-list-id">
              <option v-for="(item, i) in prestazioniOptions" :key="i" :value="item.descrizionePrestazione">
                {{ `${item.descrizionePrestazione}` }}
              </option>
            </datalist>
          </b-input-group>
        </div>
        <div v-else>
          <div v-if="!isRowEdit(row)">

            <b-form-input v-model="selectedRowEditItem.descrizionePrestazione" list="my-list-id"></b-form-input>
            <datalist id="my-list-id">
              <option v-for="(item, i) in prestazioniOptions" @change="onChangePrestazione()" :key="i"
                :value="item.descrizionePrestazione">
                {{ `${item.descrizionePrestazione}` }}
              </option>
            </datalist>
          </div>
          <span v-else>
            <b-form-input v-model="row.item.descrizionePrestazione" :disabled="true" list="my-list-id"></b-form-input>
          </span>
        </div>
      </template>
      <template v-slot:cell(quantitaErogabile)="row">
        <div>
          <b-form-input :value="row.item.quantitaErogabile" type="text" :disabled="true"></b-form-input>
        </div>

      </template>
      <template v-slot:cell(prezzo)="row">
        <div v-if="row.item.new">
          <b-form-input v-model="prestazione.prezzo" type="text" :disabled="true"></b-form-input>
        </div>
        <div v-else>
          <b-form-input v-model="selectedRowEditItem.prezzo" type="text" :disabled="true"
            v-if="!isRowEdit(row)"></b-form-input>

          <b-form-input v-else :value="row.item.prezzo + ' €'" :disabled="true"></b-form-input>
        </div>
      </template>
      <template v-slot:cell(dataErogazione)="row">
        <div v-if="row.item.new">
          <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="prestazione.dataErogazione"
            type="date"></date-picker>
        </div>
        <span v-else>
          <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="selectedRowEditItem.dataErogazione"
            type="date" v-if="!isRowEdit(row)"></date-picker>
          <span v-else>
            {{ formatDate(row.item.dataErogazione) }}
          </span>
        </span>
      </template>
      <template v-slot:cell(statoAttuale)="row">
        <span v-if="!row.item.new" style="font-weight: 700; margin-right: 3px">
          {{ row.item.statoAttuale }}
        </span>
      </template>
      <template v-slot:cell(actions)="row">
        <div v-if="row.item.new && selectedRowEditIndex == null">
          <b-container class="bv-example-row" style="gap:6px">
            <b-button :disabled="isBtnVisibile('PulisciPrestazione', row)" size="sm" v-b-tooltip.hover
              title="Pulisci Ricerca" variant="outline-warning" @click="onClickPulisciPrestazione(row)">
              <font-awesome-icon icon="trash" />
            </b-button>
            <b-button :disabled="isBtnVisibile('AggiungiPrestazione', row)" size="sm" v-b-tooltip.hover
              title="Aggiungi Prestazione" variant="outline-success" @click="onAggiungiPrestazione(row)">
              <font-awesome-icon icon="plus" />
            </b-button>

          </b-container>
        </div>
        <div v-else>
          <b-container style="gap:6px">
            <b-button v-if="isBtnConfigurazionePrestazioneVisibile(row.item)" size="sm" v-b-tooltip.hover
              title="Configura Prestazione Agenda" variant="outline-purple" @click="onClickAggiungiPrestazione(row)">
              <i class="fas fa-cog"></i>
            </b-button>
            <div v-if="!isRowEdit(row)">
              <b-button size="sm" v-b-tooltip.hover title="Conferma Modifica" variant="outline-info"
                @click="onConfermaModificaPrestazione(row)">
                <font-awesome-icon icon="check" />
              </b-button>
              <b-button size="sm" v-b-tooltip.hover title="Annulla Modifica" variant="outline-danger"
                @click="onAnnullaModifica(row)">
                <font-awesome-icon icon="times" />
              </b-button>
            </div>
            <b-button size="sm" v-if="isBtnVisibile('PrenotaVisita', row)" v-b-tooltip.hover title="Prenota Visita"
              variant="outline-primary" @click="onPrenotaAppuntamento(row)">
              <font-awesome-icon icon="calendar" />
            </b-button>
            <template>


              <b-button size="sm" v-if="!isModificaRecordPrestazione && row.item.appuntamenti.length > 0"
                v-b-tooltip.hover title="Visualizza Prenotazione/i" variant="outline-primary"
                @click="onVisualizzaPrenotazione(row)">
                <font-awesome-icon icon="calendar-check" />
              </b-button>
            </template>
            <b-button size="sm" v-if="selectedRowEditIndex == null && isRowEdit(row)"
              :disabled="row.item.appuntamenti.length > 0" v-b-tooltip.hover title="Modifica Prestazione"
              variant="outline-info" @click="onModificaPrestazione(row)">
              <font-awesome-icon icon="edit" />
            </b-button>
            <b-button v-if="selectedRowEditIndex == null" size="sm" v-b-tooltip.hover
              :disabled="row.item.appuntamenti.length > 0" title="Rimuovi Prestazione" variant="outline-danger"
              @click="onEliminaPrestazione(row)">
              <font-awesome-icon icon="trash" />
            </b-button>
          </b-container>
        </div>
      </template>
    </b-table>
    <b-modal ref="mdlPrenotazionePrestazione" id="mdlPrenotazionePrestazione" @show="onShowModal" scrollable size="xl"
      style="height: 100%" title="Disponibilita Agenda" @hide="onHideModalPrenotazione">
      <b-row style="margin-bottom: 15px">
        <b-col cols="12" style="margin-bottom: 5px" v-if="tab == 1">
          <div class="d-flex align-items-center mb-2 mt-2">
            <span class="badge rounded-circle d-flex align-items-center justify-content-center mr-2"
              style="width: 32px; height: 32px; background-color: #00a3ff; color: white; font-size: 14px"> 1</span>

            <h5 class="mb-0" style="font-weight: 600; color: #333; letter-spacing: 0.5px"><span
                style="color: #00a3ff">Seleziona Disponibilita</span></h5>
          </div>
          <hr class="mt-1 mb-3" style="border-top: 2px solid; opacity: 0.5; width: 60%" />
        </b-col>
        <b-col cols="12" style="margin-bottom: 5px" v-if="tab == 2">
          <div class="d-flex align-items-center mb-2 mt-2">
            <span class="badge rounded-circle d-flex align-items-center justify-content-center mr-2"
              style="width: 32px; height: 32px; background-color: #00a3ff; color: white; font-size: 14px"> 2</span>

            <h5 class="mb-0" style="font-weight: 600; color: #333; letter-spacing: 0.5px"><span
                style="color: #00a3ff">Conferma</span></h5>
          </div>
          <hr class="mt-1 mb-3" style="border-top: 2px solid; opacity: 0.5; width: 60%" />
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2" xl="2">
          <label class="sa-label_data">Agenda</label>
          <b-form-select id="inline-form-custom-select-pref" v-model="idAgenda" class="mb-2 mr-sm-2 mb-sm-0"
            :options="agendeOptions" value-field="id" text-field="titolo" :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
          <label class="sa-label_data">Data Riferimento <font-awesome-icon icon="calendar-day" style="cursor: pointer"
              @click="onTornaAdOggi()" /></label>
          <div style="display: flex">
            <font-awesome-icon icon="arrow-circle-left"
              style="height: 28px; width: 28px; justify-content: start; margin-right: 2px; cursor: pointer"
              @click="indietro()" />
            <b-form-group>
              <b-input-group>
                <date-picker v-model="dataRiferimentoDate" format="DD-MM-YYYY" value-type="timestamp"
                  placeholder="Seleziona Data " type="date"> </date-picker>

              </b-input-group>
            </b-form-group>
            <font-awesome-icon icon="arrow-circle-right"
              style="height: 28px; width: 28px; margin-left: 2px; cursor: pointer" @click="avanti()" />
          </div>
        </b-col>
        <b-col xs="12" sm="12" md="2" lg="2" xl="2">
          <label class="sa-label_data">Modalita Visualizzazione</label>
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio-group id="radio-group-2" v-model="periodoAgenda" :disabled="true"
              :aria-describedby="ariaDescribedby" name="radio-sub-component">
              <!-- <b-form-radio value="W">Settimana</b-form-radio> -->
              <b-form-radio value="G">Giorno</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <div class="d-flex justify-content-center" style="gap: 12px; margin-bottom: 10px;">
            <div class="text-center">
              <label class="sa-label-data">Eseguiti</label>
              <div style=" display: block ruby;">
                <div :style="{
                  minWidth: '22px',
                  height: '22px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '25px',
                  background: '#218838',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                }">{{ getNumber('ESEGUITO', disponbilitaSelezionate) }}
                </div>
              </div>
            </div>
            <div class="text-center">
              <label class="sa-label-data">Prenotati</label>
              <div style=" display: block ruby;">
                <div :style="{
                  minWidth: '22px',
                  height: '22px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '25px',
                  background: '#FFC107',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                }">{{ getNumber('PRENOTATO', disponbilitaSelezionate) }}
                </div>
              </div>
            </div>

            <div class="text-center">
              <label class="sa-label-data">Ciclo Totale</label>
              <div style=" display: block ruby;">
                <div :style="{
                  minWidth: '22px',
                  height: '22px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '25px',
                  background: '#00a3ff',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                }"> {{ selectedRowPrenotazione == null ? 0 : selectedRowPrenotazione.item.quantitaErogabile }}
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <template v-if="tab == 1">
        <template v-for="(giorni, i) in disponibilitaAgenda">
          <b-row v-if="periodoAgenda == 'G'" :key="i" style="display: flex; justify-content: center">
            <b-col cols="12" class="text-center">
              {{ dataRiferimento }} {{ getGiornoSettimana(dataRiferimento).toUpperCase() }}
              <hr />
            </b-col>
            <b-col cols="2" v-for="(disponibilita, i) in giorni.disponibilita" :key="i"
              style="cursor: pointer; margin: 3px">
              <b-card :class="{ ftActiveClass: isActiveClassCard(disponibilita), 'ft-card': true }"
                @click="onClickDisponibilita(disponibilita)">
                <b-card-text
                  style="font-weight: bold; font-size: medium; height: 100%; width: 100%; display: flex; justify-content: center"
                  class="align-middle p-1">{{ disponibilita.dalleOre }} - {{ disponibilita.alleOre }}</b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </template>
      </template>
      <template v-if="tab == 2">
        <b-row style="display: flex; justify-content: center">
          <b-col cols="12" style="text-align: center; margin-bottom: 5px">
            <span class="font-weight-bold" style="font-size: large">Slots Occupati</span> <br />
            <small> {{ selectedRowPrenotazione.item.descrizionePrestazione }}</small>
          </b-col>
          <b-col v-for="(selezione, index) in disponbilitaSelezionate" :key="index" cols="2"
            style="margin: 1px; text-align: center">
            <b-card class="ft-card">
              <b-card-text style="text-align: center; align-items: center">
                <div class="font-weight-bold" style="font-size: large">{{ getDataSistoFormat(selezione.dataRiferimento)
                }}</div>
                <div class="font-weight-bold" style="font-size: medium">{{ selezione.dalleOre }} - {{ selezione.alleOre
                }}</div>

                <div class="font-weight-bold" style="font-size: smaller">Accesso n° {{ selezione.numeroOrdine }}
                </div>
              </b-card-text>
              <b-card-text style="text-align: center; align-items: center">

              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </template>
      <template v-else></template>
      <template #modal-footer>
        <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">
          <b-button variant="primary" v-if="tab == 2" @click="tab = 1">Indietro</b-button>

          <b-button variant="secondary" v-if="tab == 1" @click="closeModal()">Chiudi</b-button>
          <b-button variant="success" v-if="tab == 1" @click="tab = 2"> Avanti </b-button>
          <b-button variant="success" v-if="tab == 2" @click="onOkConfermaAppuntamento()"> Prenota </b-button>
          <!-- <b-button variant="success" v-if="tab == 2 && selectedRowPrenotazione.item.id != '-1'" @click="onPrenotaAppuntamentoNuovaAccettazione()"> Occupa Slot Prestazione </b-button> -->
        </div>
      </template>
    </b-modal>
    <b-modal ref="mdlVisualizzaPrenotazione" id="mdlVisualizzaPrenotazione" size="large"
      style="height: 100%; width: 100%" title="Appuntamento">
      <template v-if="appuntamentoView != null">
        <b-row style="display: flex; justify-content: center ;  gap: 8px;">
          <b-col cols="12" style="text-align: center; margin-bottom: 5px"> <span class="font-weight-bold"
              style="font-size: large">Slot Occupati</span> <br /> </b-col>
          <b-col v-for="(selezione, index) in appuntamentoView" :key="index" cols="auto"
            style="margin: 1px; text-align: center;">
            <b-card :class="['ft-card', getClassColorBorder(selezione)]" style="height: 100%; width: 100%;">
              <b-card-text style="text-align: center; align-items: center">
                <div class="font-weight-bold" style="font-size: large">{{ getDataSistoFormat(selezione.dataRiferimento)
                }}</div>
                <div class="font-weight-bold" style="font-size: medium">{{ getOrario(selezione.dataOraInizio) }} - {{
                  getOrario(selezione.dataOraFine) }}</div>
                <div class="font-weight-bold" style="font-size: small">Accesso n° {{ selezione.numeroOrdine }}</div>
                <div class="font-weight-bold" style="font-size: small" v-if="selezione.statoAttuale">{{
                  selezione.statoAttuale }}</div>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button variant="secondary" @click="closeModalViewAppuntamento()">Chiudi</b-button>
      </template>
    </b-modal>

    <b-modal ref="mdlAggiungiModificaPrestazioneAgenda" @shown="onShownNuovaPrestazioneAgenda" @show="onShow"
      id="mdlAggiungiModificaPrestazioneAgenda" size="large" style="height: 100%; width: 100%"
      title="Configurazione Prestazione Agenda">
      <template>
        <b-row>
          <b-col cols="12">
            <label class="sa-ft-label">
              Agenda
            </label>
            <b-form-select id="inline-form-custom-select-pref" v-model="prestazioneAgenda.idAgenda"
              class="mb-2 mr-sm-2 mb-sm-0" :options="agendePresidioOptions" @change="onSelezionaAgenda" value-field="id"
              text-field="titolo" :value="null">
              <template #first>
                <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label class="sa-ft-label">Codice Prestazione</label>
            <div class="sa-search-search-wrapper">
              <b-form-input type="text" name="costo" min="0" class="form-control"
                v-model="prestazioneAgenda.codicePrestazione"></b-form-input>
              <!-- <button @click="onClickRicerca" class="sa-ft-floating-btn primary" title="Cerca">
							<i class="fas fa-search"></i>
						</button> -->
            </div>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label class="sa-ft-label">Descrizione Prestazione</label>
            <b-form-textarea v-model="prestazioneAgenda.descrizionePrestazione" rows="5" no-resize></b-form-textarea>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label class="sa-ft-label">Costo</label>
            <b-form-input type="number" name="costo" min="0" class="form-control"
              v-model="prestazioneAgenda.costo"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label class="sa-ft-label">Quantita Erogabile</label>
            <b-form-input type="number" name="quantita" min="0" class="form-control"
              v-model="prestazioneAgenda.quantitaErogabile"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label class="sa-ft-label">Durata media (in minuti)</label>
            <b-form-input type="number" min="0" name="durata" class="form-control"
              v-model="prestazioneAgenda.durata"></b-form-input>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button variant="secondary" @click="onAnnullaAggiungiPrestazione()">Chiudi</b-button>
        <b-button variant="success" @click="onClickSalvaPrestazioneAgenda()">Salva Prestazione</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import toast from "../../../../template/layout/utility/sa-toast";
export default {
  mixins: [UtilityMixin],
  props: {
    tipologiaRicetta: {
      type: [String, Object],
      default: null
    }
  },
  components: { DatePicker },
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  computed: {

    prestazioniItems() {
      return [...this.itemsPrestazioni, this.prestazione];
    },
    prestazioni() {
      let me = this;
      return new Set(me.prestazioniOptions);
    },
    disponibilitaAgenda() {
      let me = this;
      let returnValue = [
        {
          giorno: me.dataRiferimento,
          disponibilita: [],
        },
      ];
      if (me.disponibilitaAgendaItems != null)
        if (me.disponibilitaAgendaItems[0]) {
          let disponibilita = me.disponibilitaAgendaItems[0].disponibilita;
          for (let dis of disponibilita) {
            let listaAccessi = dis.appuntamento.length;
            for (let i = 0; i < listaAccessi; i++) {
              let slotDisp = false;
              if (dis.appuntamento[i] === null) {
                slotDisp = true;
              }
              if (slotDisp) {
                const dataI = new Date(`${dis.dataRiferimento}T${dis.dalleOre}`);
                if (new Date() < dataI) {
                  returnValue[0].disponibilita.push(dis);
                }
              }
            }
          }
          returnValue[0].disponibilita = new Set(returnValue[0].disponibilita);

        }

      return returnValue;
    },
  },
  mounted() {
    this.selectedRowDetail = null;
    this.selectedRowEditIndex = null;
    this.selectedRowEditItem = null;
    this.dataRiferimento = moment(new Date().getTime()).format("YYYY-MM-DD");
  },
  data() {
    return {
      localData: {},
      dataRiferimentoDate: new Date().getTime(),
      prestazioneAgenda: {
        idAgenda: null,
        codicePrestazione: "",
        descrizionePrestazione: "",
        costo: 0,
        quantitaErogabile: 1,
        durata: 0,
        id: null,
      },
      agendaSelezionata: {},
      selectedRowEditIndex: null,
      selectedRowEditItem: null,
      accettazioneJson: {},
      agendePresidioOptions: [],
      itemsPrestazioni: [],
      isModificaRecordPrestazione: false,
      prestazioniOptions: [],
      pathResourcePrestazioni: "/agendaprestazioni/presidio",
      pathResourceAgenda: "/agende/prestazione",
      pathResourceAgendaDisponibilita: "/agendadisponibilita",
      pathResourceAgendaAppuntamento: "/agendaappuntamenti",
      dataRiferimento: "",
      headersPrestazioni: [
        {
          label: "Quantita",
          key: "quantita",
          thStyle: "width: 2rem",
        },
        {
          label: "Cod.Prestazione",
          key: "codicePrestazione",
          thStyle: "width: 5rem",
        },
        {
          label: "Prestazione",
          key: "descrizionePrestazione",
        },
        {
          label: "Erogabile",
          key: "quantitaErogabile",
          thStyle: "width: 6rem",
        },
        {
          label: "Prezzo",
          key: "prezzo",
          thStyle: "width: 6rem",
        },
        {
          label: "Stato Prestazione",
          key: "statoAttuale",
        },

        {
          label: "Slots",
          key: "appuntamenti",
          thStyle: "width: 12rem",
          tdClass: "d-flex align-items-center justify-content-center"

        },

        /**    {
          label: "Data Erogazione",
          key: "dataErogazione",
        },*/
        {
          label: "",
          key: "actions",
          tdClass: "sa-table-column-action-double",
        },
      ],
      tab: 1,
      disponibilitaAgendaItems: [],
      disponbilitaSelezionate: [],
      agendeOptions: [],
      idAgenda: null,
      prestazione: {
        id: "-1",
        quantita: 1,
        idListino: "---",
        descrizionePrestazione: null,
        codicePrestazione: null,
        statoAttuale: "PRESA IN CARICO",
        prezzo: 0,
        dataErogazione: null,
        new: true,
        appuntamenti: [],
      },
      periodoAgenda: "G",
      appuntamentoView: [],
      selectedRowPrenotazione: null,
      styleBadgeForDisponibilitaSelezionate: {
        minWidth: "22px",
        height: "22px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        background: "#ffc107",
        color: "white",
        fontWeight: "600",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
      },
    };
  },
  methods: {
    init(jsonData, accettazioneJson) {
      this.accettazioneJson = accettazioneJson;
      if (jsonData) {
        this.localData = jsonData;
        this.itemsPrestazioni = this.localData.prestazioni;
      }
      this.loadPrestazioniAgendaPresidio();
    },
    getNumber(stato, appuntamenti) {
      if (!appuntamenti) {
        return 0;
      }
      return appuntamenti.filter(a => a.statoAttuale === stato).length;

    },


    getClassColorBorder(row) {
      if (!row.statoAttuale) {
        return;
      }
      switch (row.statoAttuale) {
        case "PRENOTATO":
          return 'ft-card-yellow';
        case "ESEGUITO":
          return 'ft-card-green';
        default:
          return 'ft-card-red'
      }
    },

    setPrestazioni(prestazioni) {
      this.itemsPrestazioni = prestazioni;
    },
    onChangePrestazione(e) {
      console.log("change prestazione", e);

    },
    onClickPulisciPrestazione(row) {
      let item = row.item;

      item.prezzo = 0;
      item.quantita = 1;
      item.quantitaErogabile = 0;
      item.descrizionePrestazione = null;
      item.codicePrestazione = null;

    },
    onSelezionaAgenda(agenda) {
      this.openShowModalLoading();
      UtilityMixin.methods.loadDataResources("/agende/" + agenda, {}, this.onSelezionaAgendaSuccess, this.onSelezionaAgendaError);
    },
    getGiornoSettimana(dataString) {
      const giornoSettimana = moment(dataString).locale('it').format('dddd');
      return giornoSettimana;
    },

    onSelezionaAgendaSuccess(response) {
      this.agendaSelezionata = response.data.data;
      this.prestazioneAgenda.durata = this.agendaSelezionata.durataAppuntamento;
      let find = this.agendaSelezionata.prestazioni.find(e => e.codicePrestazione == this.prestazioneAgenda.codicePrestazione);
      console.log("find", find);

      if (find) {
        this.prestazioneAgenda.id = find.id;
      } else {
        this.prestazioneAgenda.id = "-1"
      }
      this.closeShowModalLoading();
    },
    onSelezionaAgendaError(error) {
      error;
      this.closeShowModalLoading();
    },
    onClickAggiungiPrestazione(row) {
      this.prestazioneAgenda = {
        id: null,
        idAgenda: null,
        codicePrestazione: row.item.codicePrestazione,
        descrizionePrestazione: row.item.descrizionePrestazione,
        costo: row.item.prezzo,
        quantitaErogabile: row.item.quantita,
        durata: 0
      },
        this.$refs.mdlAggiungiModificaPrestazioneAgenda.show();
    },
    onShownNuovaPrestazioneAgenda() {
      console.log(this.agendePresidioOptions);


    },

    onShow() {
      this.loadAgendePresidio();
    },

    onAnnullaAggiungiPrestazione() {
      this.prestazioneAgenda = {
        idAgenda: null,
        codicePrestazione: "",
        descrizionePrestazione: "",
        costo: 0,
        id: null,
        quantitaErogabile: 1,
        durata: 0
      }
      this.$refs.mdlAggiungiModificaPrestazioneAgenda.hide();
    },
    onClickSalvaPrestazioneAgenda() {

      this.saveResource(
        "/agendaprestazioni",
        this.prestazioneAgenda,
        this.saveSuccess,
        this.saveError
      );


    },
    saveSuccess(response) {
      console.log(response);
      let prestazione = response.data.data;
      prestazione;

    },
    saveError(err) {
      console.log(err);

    },

    onAddPrestazione(prestazione) {
      let me = this;
      console.log(prestazione);
      console.log(me.jsonData);
    },
    onPrenotaAppuntamento(row) {
      let me = this;
      me.selectedRowPrenotazione = row;
      let appuntamenti = [];

      if (row.item.appuntamentiTmp && row.item.appuntamentiTmp.length > 0) {
        appuntamenti = JSON.parse(JSON.stringify(row.item.appuntamentiTmp));
      } else if (row.item.appuntamenti && row.item.appuntamenti.length > 0) {
        appuntamenti = JSON.parse(JSON.stringify(row.item.appuntamenti));
      }
      me.disponbilitaSelezionate = appuntamenti;
      me.loadAgende();
      me.$refs.mdlPrenotazionePrestazione.show();
    },
    onSbloccoSlot(row) {
      console.log(row.item.appuntamenti);
      row.item.appuntamenti.filter(e => e.statoAttuale == 'PRENOTATO')
      this.onAnnullaSelezionato();
    },
    onAnnullaSelezionato() {
      let me = this;
      me.tab = 1;
      me.disponbilitaSelezionate = [];
    },
    onShowModal() {
      // let me = this;
      // me.disponbilitaSelezionate = null;
    },
    isBtnVisibile(key, row) {
      switch (key) {
        case "PrenotaVisita":
          return row.item.appuntamenti.length < row.item.quantitaErogabile && this.selectedRowEditItem == null;
        case "AggiungiPrestazione":
          return row.item.descrizionePrestazione == null || row.item.descrizionePrestazione == '';
        case "PulisciPrestazione":
          return (row.item.descrizionePrestazione == null || row.item.descrizionePrestazione == '')
        default:
          return false;
      }
    },
    getOrario(data) {
      return moment(data).format("HH:mm");
    },
    isBeforeDate(slot) {
      const dataA = new Date(`${slot.dataRiferimento}T${slot.dalleOre}`);
      return new Date() > dataA;
    },
    getDataSistoFormat(data) {
      let date = new Date(data);
      return moment(date).format("DD-MM-YYYY");
    },
    loadAgende() {
      let me = this;
      me.agendeOptions = [];
      UtilityMixin.methods.loadDataResources(me.pathResourceAgenda, { idPresidio: me.accettazioneJson.idPresidio, codicePrestazione: me.selectedRowPrenotazione.item.codicePrestazione }, me.loadAgendeSuccess, me.loadAgendeError);
    },
    loadAgendeSuccess(response) {
      let me = this;
      me.agendeOptions = response.data.data;
    },

    loadAgendeError(error) {
      console.log(error);
    },

    loadAgendePresidio() {
      this.agendePresidioOptions = [];
      this.loadDataResources("/agende", { idPresidio: this.accettazioneJson.idPresidio }, this.loadAgendePresidioSuccess, this.loadAgendePresidioError);
    },
    loadAgendePresidioSuccess(response) {
      this.agendePresidioOptions = response.data.data;

    },
    loadAgendePresidioError(error) {
      console.log(error);
    },

    loadPrestazioniRicetta(id) {
      UtilityMixin.methods.loadDataResources("/accettazionericetteprestazioni", { idRicetta: id }, this.loadPrestazioniRicettaSuccess, this.loadPrestazioniRicettaError);
    },
    loadPrestazioniRicettaSuccess(response) {
      this.itemsPrestazioni = [...response.data.data.list, ...this.prestazione];
    },
    loadPrestazioniRicettaError(error) {
      error;
    },
    onHideModalPrenotazione() {
      let me = this;
      me.tab = 1;
      me.disponbilitaSelezionate = [];
    },
    isRowEdit(row) {
      let me = this;
      return row == null ? true : row.index == me.selectedRowEditIndex ? false : true;
    },
    closeModalViewAppuntamento() {
      let me = this;
      me.$refs.mdlVisualizzaPrenotazione.hide();
    },
    onVisualizzaPrenotazione(row) {
      let me = this;
      me.appuntamentoView = row.item.appuntamenti;
      me.$refs.mdlVisualizzaPrenotazione.show();
    },
    getColorBackGround(row) {
      let color = "#b6b5b5";
      if (row.item) {
        if (row.item.appuntamenti) {
          color = row.item.appuntamenti.length == row.item.quantitaErogabile ? "#00a3ff" : "#ffc107";
        }
      }
      return color;
    },
    isBtnConfigurazionePrestazioneVisibile(item) {
      if (!item || !item.descrizionePrestazione || item.descrizionePrestazione.trim() === '') {
        return false;
      }
      if (item.quantitaErogabile == 0) {
        return true;
      }
      const testoInput = item.descrizionePrestazione.trim().toLowerCase();
      const descrizioniEsistenti = this.prestazioniOptions.map(option => {
        return (option?.descrizionePrestazione || '').trim().toLowerCase();
      });
      const esisteGia = descrizioniEsistenti.includes(testoInput);
      return !esisteGia;
    },
    onModificaPrestazione(row) {
      let me = this;

      if (me.selectedRowEditIndex == null) {
        this.isModificaRecordPrestazione = true;
        me.selectedRowEditIndex = row.index;
        me.selectedRowEditItem = JSON.parse(JSON.stringify(row.item));
      }
    },

    onAnnullaModifica() {
      let me = this;
      me.selectedRowEditIndex = null;
      me.selectedRowEditItem = null;
      this.isModificaRecordPrestazione = false;
    },
    closeModal() {
      let me = this;
      me.$refs.mdlPrenotazionePrestazione.hide();
    },
    onConfermaModificaPrestazione() {
      let me = this;
      if (me.selectedRowEditIndex != null) {
        //let nuovaQuantita = Number(me.selectedRowEditItem.quantita);

        if (me.selectedRowEditItem.quantita == 0) {
          toast.warning("Quantita Selezionata non può essere 0 !")
          return;
        }

        console.log("selezionata ", me.selectedRowEditItem);

        me.$set(me.prestazioniItems, me.selectedRowEditIndex, JSON.parse(JSON.stringify(me.selectedRowEditItem)));
        me.selectedRowEditIndex = null;


        me.selectedRowEditItem = null;
        this.isModificaRecordPrestazione = false;


      }
      this.localData.prestazioni = me.prestazioniItems.filter((e) => e.new != true);
      this.$emit("updatePrestazioni", this.localData.prestazioni);
    },

    onEliminaPrestazione(row) {
      let me = this;
      me.prestazioniItems.splice(row.index, 1);
      this.localData.prestazioni = me.prestazioniItems.filter((e) => e.new != true);
      this.$emit("updatePrestazioni", this.localData.prestazioni);
    },
    isActiveClassCard(disponibilita) {
      if (!this.disponbilitaSelezionate || this.disponbilitaSelezionate.length === 0) return false;

      return this.disponbilitaSelezionate.some((e) => {
        let a = e.alleOre === disponibilita.alleOre;
        let b = e.dalleOre === disponibilita.dalleOre;

        // Normalizziamo le date usando moment per essere sicuri del formato YYYY-MM-DD
        let dateA = moment(e.dataRiferimento).format("YYYY-MM-DD");
        let dateB = moment(disponibilita.dataRiferimento).format("YYYY-MM-DD");
        let c = dateA === dateB;

        return a && b && c;
      });
    },
    onOkConfermaAppuntamento() {
      let me = this;
      // 1. Creiamo un nuovo array temporaneo pulito
      let nuoviAppuntamenti = [];

      for (let disponibilita of me.disponbilitaSelezionate) {
        if (!disponibilita.id) {
          let dataInizio = new Date(disponibilita.dataRiferimento);
          let dataFine = new Date(disponibilita.dataRiferimento);
          const [oreInizio, minInizio] = disponibilita.dalleOre.split(':').map(Number);
          const [oreFine, minFine] = disponibilita.alleOre.split(':').map(Number);
          let dataOraInizio = dataInizio.setHours(oreInizio, minInizio, 0, 0);
          let dataOraFine = dataFine.setHours(oreFine, minFine, 0, 0);
          let appuntamentoAgenda = {
            idAgenda: me.idAgenda,
            cognome: me.accettazioneJson.accettazioneAnagrafica.cognome,
            tipoIdentificativo: "CF",
            identificativoAppuntamento: me.accettazioneJson.accettazioneAnagrafica.identificativo,
            codicePrestazione: me.selectedRowPrenotazione.item.codicePrestazione,
            descrizionePrestazione: me.selectedRowPrenotazione.item.descrizionePrestazione,
            dataOraInizio: dataOraInizio,
            dataOraFine: dataOraFine,
            dalleOre: disponibilita.dalleOre,
            alleOre: disponibilita.alleOre,
            dataRiferimento: disponibilita.dataRiferimento,
            costo: me.selectedRowPrenotazione.item.prezzo,
            nome: me.accettazioneJson.accettazioneAnagrafica.nome,
            dataNascita: null,
            statoAttuale: disponibilita.statoAttuale,
            note: null,
            numeroOrdine: disponibilita.numeroOrdine
          };
          nuoviAppuntamenti.push(appuntamentoAgenda);
        } else {
          nuoviAppuntamenti.push(JSON.parse(JSON.stringify(disponibilita)));
        }
      }
      me.selectedRowPrenotazione.item.appuntamenti = nuoviAppuntamenti;
      me.$refs.mdlPrenotazionePrestazione.hide();
    },

    onClickDisponibilita(item) {
      let me = this;
      const indexSelezionato = me.disponbilitaSelezionate.findIndex((e) => {

        const dataE = typeof e.dataRiferimento === 'string' ? e.dataRiferimento.split('T')[0] : new Date(e.dataRiferimento).toISOString().split('T')[0];
        const dataItem = typeof item.dataRiferimento === 'string' ? item.dataRiferimento.split('T')[0] : new Date(item.dataRiferimento).toISOString().split('T')[0];

        return e.dalleOre === item.dalleOre &&
          e.alleOre === item.alleOre &&
          dataE === dataItem;
      });


      if (indexSelezionato !== -1) {
        console.log(item);
        if (me.disponbilitaSelezionate[indexSelezionato].id) {
          toast.warning("Non e possibile rimuovere un appuntamento salvato, procedere all'eliminazione dall'interfaccia o sposta appuntamento")
          return;
        } else {
          me.disponbilitaSelezionate.splice(indexSelezionato, 1);
        }
      } else {
        const quantitaErogabile = this.selectedRowPrenotazione.item.quantitaErogabile;
        if (me.disponbilitaSelezionate.length < quantitaErogabile) {
          item.statoAttuale = "PRENOTATO";
          me.disponbilitaSelezionate.push(item);
        } else {
          toast.warning("Numero Totale Erogabile è di " + quantitaErogabile);
          return;
        }
      }

      me.disponbilitaSelezionate = me.disponbilitaSelezionate.sort((a, b) => {
        const dataStringA = typeof a.dataRiferimento === 'string' ? a.dataRiferimento.split('T')[0] : new Date(a.dataRiferimento).toISOString().split('T')[0];
        const dataStringB = typeof b.dataRiferimento === 'string' ? b.dataRiferimento.split('T')[0] : new Date(b.dataRiferimento).toISOString().split('T')[0];
        const dataA = new Date(`${dataStringA}T${a.dalleOre}`);
        const dataB = new Date(`${dataStringB}T${b.dalleOre}`);
        return dataA - dataB;
      });
      me.disponbilitaSelezionate.forEach((appuntamento, index) => {
        const numeroAppuntamento = index + 1;
        appuntamento.numeroOrdine = numeroAppuntamento;
      });
    },
    onAggiungiPrestazione(row) {

      // let item = row.item;




      this.$emit("onAggiungiPrestazione", row);

      this.resetPrestazione();
    },
    onTornaAdOggi() {
      let me = this;
      let dataAttuale = new Date();
      me.dataRiferimento = moment(dataAttuale).format("YYYY-MM-DD");
    },
    indietro() {
      let me = this;
      switch (me.periodoAgenda) {
        case "G":
          me.dataRiferimentoDate = moment(me.dataRiferimentoDate).subtract(1, "days").valueOf();
          me.dataRiferimento = moment(me.dataRiferimentoDate).format("YYYY-MM-DD");
          break;
        case "W":
          me.dataRiferimento = moment(me.dataRiferimento).subtract(1, "weeks").format("YYYY-MM-DD");
          break;
        default:
          break;
      }
    },
    avanti() {
      let me = this;
      switch (me.periodoAgenda) {
        case "G":
          me.dataRiferimentoDate = moment(me.dataRiferimentoDate).add(1, "days").valueOf();
          me.dataRiferimento = moment(me.dataRiferimentoDate).format("YYYY-MM-DD");
          break;
        case "W":
          me.dataRiferimento = moment(me.dataRiferimentoDate).add(1, "weeks").format("YYYY-MM-DD");
          break;
        default:
          break;
      }
    },
    resetPrestazione() {
      this.prestazione = {
        quantita: 1,
        idListino: "---",
        prezzo: 0,
        quantitaErogabile: 0,
        statoAttuale: "PRESA IN CARICO",
        descrizionePrestazione: null,
        codicePrestazione: null,
        dataErogazione: null,
        new: true,
        appuntamenti: [],
      };
    },
    loadPrestazioniAgendaPresidio() {
      let me = this;
      me.prestazioniOptions = [];
      if (me.accettazioneJson.idPresidio) {
        this.openShowModalLoading();
        UtilityMixin.methods.loadDataResources(me.pathResourcePrestazioni, { idPresidio: me.accettazioneJson.idPresidio }, me.loadPrestazioniAgendaPresidioSuccess, me.loadPrestazioniAgendaPresidioError);
      }
    },
    loadPrestazioniAgendaPresidioSuccess(response) {
      let me = this;
      me.prestazioniOptions = response.data.data;
      this.closeShowModalLoading();
    },
    loadPrestazioniAgendaPresidioError(error) {
      console.log(error);
    },
    onSelezionaData() {
      this.$refs.mdlSelezionaData.show();
    },

    validazionePrestazioneRecord() {
      let esito = true;
      let msg = "";

      return { esito: esito, msg: msg };
    },


    loadAgendaDisponibilita() {
      let me = this;
      if (me.selectedRowPrenotazione) {
        let itemFIlter = {
          language: "it",
          idAgenda: me.idAgenda,
          periodo: me.periodoAgenda,
          riferimento: me.dataRiferimento,
          codicePrestazione: this.selectedRowPrenotazione.item.codicePrestazione,
        };
        me.disponibilitaAgendaItems = [];
        this.openShowModalLoading();
        UtilityMixin.methods.loadDataResources(me.pathResourceAgendaDisponibilita, itemFIlter, me.loadAgendaDisponibilitaSuccess, me.loadAgendaDisponibilitaError);
      }
    },
    loadAgendaDisponibilitaSuccess(response) {
      let me = this;
      me.disponibilitaAgendaItems = response.data.data;
      this.closeShowModalLoading();
    },
    loadAgendaDisponibilitaError(error) {
      console.log(error);
      this.closeShowModalLoading();
    },
  },
  watch: {
    dataRiferimentoDate: function (params) {
      this.dataRiferimento = moment(params).format("YYYY-MM-DD");

    },
    disponbilitaSelezionate: function (params) {
      if (params && this.selectedRowPrenotazione)
        if (params.length == this.selectedRowPrenotazione.item.quantitaErogabile) {
          this.styleBadgeForDisponibilitaSelezionate.background = "#00a3ff";
        } else {
          this.styleBadgeForDisponibilitaSelezionate.background = "#ffc107";
        }
    },
    dataRiferimento: function (params) {
      let me = this;
      if (params) {
        me.loadAgendaDisponibilita();
      }
    },
    periodoAgenda: function (params) {
      let me = this;
      if (params) {
        me.loadAgendaDisponibilita();
      }
    },
    idAgenda: function (params) {
      let me = this;
      if (params) {
        me.loadAgendaDisponibilita();
      }
    },
    "prestazione.quantita": function (params) {
      let me = this;
      console.log("prestazione.quantita", params);

      if (params >= 1 && me.prestazione.descrizionePrestazione != null) {
        let filter = me.prestazioniOptions.find((a) => `${a.descrizionePrestazione}` === me.prestazione.descrizionePrestazione);
        if (filter) {
          let prezzoPrestazione = filter.costo;
          me.prestazione.prezzo = prezzoPrestazione * params;
          me.prestazione.codicePrestazione = filter.codicePrestazione;
          me.prestazione.quantitaErogabile = filter.quantitaErogabile;
        }
      }
    },
    "prestazione.descrizionePrestazione": function (params) {
      if (params) {
        let me = this;
        let filter = me.prestazioniOptions.find((a) => `${a.descrizionePrestazione}` === params);
        if (filter) {
          let prezzoPrestazione = filter.costo;
          me.prestazione.prezzo = prezzoPrestazione * me.prestazione.quantita;
          me.prestazione.codicePrestazione = filter.codicePrestazione;
          me.prestazione.quantitaErogabile = filter.quantitaErogabile;
        }
      }
    },
    "selectedRowEditItem.quantita": function (params) {
      let me = this;
      console.log("params ", params);

      if (params >= 1 && me.selectedRowEditItem.descrizionePrestazione != null) {
        let filter = me.prestazioniOptions.find((a) => `${a.descrizionePrestazione}` === me.selectedRowEditItem.descrizionePrestazione);
        if (filter) {
          let prezzoPrestazione = filter.costo;
          me.selectedRowEditItem.prezzo = prezzoPrestazione * params;
          me.selectedRowEditItem.codicePrestazione = filter.codicePrestazione;
          me.selectedRowEditItem.quantitaErogabile = filter.quantitaErogabile;
        }
      }
    },
    "selectedRowEditItem.descrizionePrestazione": function (params) {
      if (params) {
        let me = this;
        let filter = me.prestazioniOptions.find((a) => `${a.descrizionePrestazione}` === params);
        if (filter) {
          let prezzoPrestazione = filter.costo;
          me.selectedRowEditItem.prezzo = prezzoPrestazione * me.selectedRowEditItem.quantita;
          me.selectedRowEditItem.codicePrestazione = filter.codicePrestazione;
          me.selectedRowEditItem.quantitaErogabile = filter.quantitaErogabile;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ft-card {
  border: 1px solid #b6b5b5 !important;
  border-radius: 12px;
  padding: 2px;
  transition: all 0.1s linear;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  background: #ffffff;
  cursor: pointer;
}

.ft-card .card-body {
  padding: 5px !important;
}

.ft-card-red {
  border-color: #DC3545 !important;
}

.ft-card-green {
  border: 1px solid #218838 !important;
}

.ft-card-yellow {
  border: 1px solid #FFC107 !important;
}

.ft-card-purple {
  border: 1px solid #a752d89d !important;
}


.ft-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.ftActiveClass,
.ftActiveClass:hover {
  box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
  border: 2px solid #00a3ff !important;
  border-color: #00a3ff !important;
}
</style>
